import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";

export const AddOperatorType = () => {
    const navigate = useNavigate();
    const [name, setName] = useState<string>("");
    const [code, setCode] = useState<string>("");
    const [category, setCategory] = useState<string>("human");

    const [requiresHuman, setRequiresHuman] =
        useState<string>("No");

    const [isAutonomous, setIsAutonomous] =
        useState<string>("No");

    const [isRemote, setIsRemote] =
        useState<string>("No");

    const [enabled, setEnabled] =
        useState<string>("No");

    const [description, setDescription] =
        useState<string>("");

    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);


    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            code: code.trim(),
            name: name.trim(),
            category: category.trim(),
            requires_human: requiresHuman === "Yes",
            is_autonomous: isAutonomous === "Yes",
            is_remote: isRemote === "Yes",
            description: description.trim(),
            is_active: enabled === "Yes"
        };

        await axios
            .post(
                `${baseURL}operator-types/`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    withCredentials: false
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error(
                    "Error creating operator type:",
                    error
                );
            });
    };

    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Add Operator Type
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Operator Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={name}
                                            placeholder="e.g. Human Driver"
                                            onChange={(e) =>
                                                setName(e.target.value)
                                            }
                                            required
                                        />
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Operator Code{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            required
                                        >
                                            <option value="">
                                                Select Code
                                            </option>

                                            <option value="HUMAN_DRIVER">
                                                HUMAN_DRIVER
                                            </option>

                                            <option value="AUTONOMOUS_OPERATOR">
                                                AUTONOMOUS_OPERATOR
                                            </option>

                                            <option value="REMOTE_OPERATOR">
                                                REMOTE_OPERATOR
                                            </option>
                                        </select>
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Category{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={category}
                                            onChange={(e) =>
                                                setCategory(e.target.value)
                                            }
                                            required
                                        >
                                            <option value="human">
                                                Human
                                            </option>

                                            <option value="autonomous">
                                                Autonomous
                                            </option>

                                            <option value="remote">
                                                Remote
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Requires Human?
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={requiresHuman}
                                            onChange={(e) =>
                                                setRequiresHuman(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Autonomous?
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={isAutonomous}
                                            onChange={(e) =>
                                                setIsAutonomous(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Remote?
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={isRemote}
                                            onChange={(e) =>
                                                setIsRemote(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Active?
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={enabled}
                                            onChange={(e) =>
                                                setEnabled(e.target.value)
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Description
                                        </label>

                                        <textarea
                                            rows={2}
                                            value={description}
                                            onChange={(e) =>
                                                setDescription(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="Enter operator type description"
                                            className="w-full p-4 border border-gray-300 rounded-md bg-white resize-none outline-none focus:border-primary"
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">

                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-secondary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>
                </div>
            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};